module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-loader-before"
  }, [_c('Loader'), _vm._v(" "), _c('hr', {
    staticClass: "hr-33"
  }), _vm._v(" "), _c('hr', {
    staticClass: "hr-66"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2005311e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/loader-before.vue
// module id = 1990
// module chunks = 2